import { useEffect, useRef, useState } from "react";
import { SplitPayment, SplitPaymentRow, calculateRemainingAmount, toSplitPaymentRows, toSplitPayments, validateSplitPayments } from "./splitPayments";

type AttemptWithSplit = {
    id: number;
    split_payments?: Array<SplitPayment>;
};

export const useSplitPayments = (orderTotal: number, electronicPaymentMethod: string, isFormOpen: boolean, latestAttempt: AttemptWithSplit | null) => {
    const [rows, setRows] = useState<Array<SplitPaymentRow>>([]);
    const carriedOverAttemptId = useRef<number | null>(null);
    const latestAttemptId = latestAttempt?.id ?? null;
    const latestSplitPayments = latestAttempt?.split_payments;

    useEffect(() => {
        if (!isFormOpen || latestAttemptId === null || carriedOverAttemptId.current === latestAttemptId) return;
        carriedOverAttemptId.current = latestAttemptId;
        if (!latestSplitPayments?.length) return;
        setRows((currentRows) => (currentRows.length ? currentRows : toSplitPaymentRows(latestSplitPayments)));
    }, [isFormOpen, latestAttemptId, latestSplitPayments]);

    const validation = validateSplitPayments(orderTotal, rows, electronicPaymentMethod);
    const areRowsFilled = rows.every((row) => row.payment_method && Number(row.amount) !== 0);

    const splitPayments = {
        rows,
        setRows,
        remainingAmount: calculateRemainingAmount(orderTotal, rows),
        validation,
        visibleError: areRowsFilled && !validation.isValid ? validation.error : null,
        payments: toSplitPayments(rows),
    };
    return splitPayments;
};
